import { render, staticRenderFns } from "./shipment-data.vue?vue&type=template&id=7083c01a&scoped=true&"
import script from "./shipment-data.vue?vue&type=script&lang=js&"
export * from "./shipment-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7083c01a",
  null
  
)

export default component.exports